import React, { useState } from 'react';
import {  makeStyles } from '@material-ui/core/styles';
import { TextField, InputAdornment, Button } from '@material-ui/core';
import { Send, KeyboardArrowLeft, StarRate } from '@material-ui/icons';
import { useForm, Controller } from 'react-hook-form';
import { fb, admin } from '../utils/Firebase';
import { apiSettings } from '../utils/ApiSettings';
import { getTokenSii } from '../utils/getTokenSii';

const FormLiquidation = props => {

    const [isLoading, setIsLoading] = useState(false);
    const { data, setData, numberFormat, setIsReady, dispatch, setVisibleModal, setServices, setAffiliation } = props;
    const { handleSubmit, control, errors, getValues } = useForm();

    const classes = useStyles();

    const onSubmit = async info => {
        //setVisibleBackdrop(true);
        setIsReady(false);
        setIsLoading(true);
        const token = await getTokenSii();
        const response = await busquedaExpedientes(token, data.identificacion);
        setServices(e => {
            return { ...e, ...{ cert: {
                name: response.expedientes[0].certificados[0].descripcioncertificado,
                value: response.expedientes[0].certificados[0].valor
            }}}
        })
        await processPNPJ(info);
        data.afiliado === '1' && await processAffiliate(info);
        //setVisib(leBackdrop(false);
        setIsReady(true);
        setIsLoading(false);
        setVisibleModal(true);
        await handleSaveIndicator(response.expedientes[0].organizaciontextual);
    }

    // const handleSaveIndicator = async organizacion => {
    //     try {
    //         await fb.firestore().collection('indicador').add({
    //             razonsocial: data.nombre.toLowerCase(),
    //             matricula: data.matricula,
    //             tipo: organizacion.toLowerCase(),
    //             fechaliquidacion: new Date()
    //         });
    //     }catch(e) {
    //         console.log(e);
    //     }
    // }

    const handleSaveIndicator = organizacion => {
        fb.firestore().collection('indicador').add({
            razonsocial: data.nombre.toLowerCase(),
            matricula: data.matricula,
            tipo: organizacion.toLowerCase(),
            fechaliquidacion: new Date()
        }).then(() => {
            handleCheckMounth();
        }).catch(e => console.log(e));
    }

    const handleCheckMounth = () => {
        const date = new Date();
        const mounth = date.getMonth()+1;
        const year = date.getFullYear();

        switch (mounth) {
            case 1:
                return setDataLiquidation(year, "enero", mounth);

            case 2:
                return setDataLiquidation(year, "febrero", mounth);

            case 3:
                return setDataLiquidation(year, "marzo", mounth);

            case 4:
                return setDataLiquidation(year, "abril", mounth);

            case 5:
                return setDataLiquidation(year, "mayo", mounth);

            case 6:
                return setDataLiquidation(year, "junio", mounth);

            case 7:
                return setDataLiquidation(year, "julio", mounth);

            case 8:
                return setDataLiquidation(year, "agosto", mounth);

            case 9:
                return setDataLiquidation(year, "septiembre", mounth);

            case 10:
                return setDataLiquidation(year, "octubre", mounth);

            case 11:
                return setDataLiquidation(year, "noviembre", mounth);

            case 12:
                return setDataLiquidation(year, "diciembre", mounth);
        }
    }

    const setDataLiquidation = async (year, mounthText, mountNum ) => {
        try {
            const stadistics = fb.firestore().collection("estadisticas");

            stadistics.doc('liquidaciones').collection(String(year)).doc(mounthText).set({
                mes: mountNum,
                cantidad: admin.increment(1)
            }, { merge: true })
        }catch(e) {
            console.log(e);
        }
    }

    const busquedaExpedientes = async (token, id) => {
        const { uri, credentials } = apiSettings;
        credentials.token = token;
        credentials.matriculainicial = '';
        credentials.nombreinicial = '';
        credentials.identificacion = id;
        credentials.semilla = 0

        try {
            const response = await fetch(`${uri}busquedaExpedientes`,  {
                method: 'POST',
                body: JSON.stringify(credentials)
            });

            if(response.ok) {
                const data = await response.json();
                return data;
            }
        }catch(e) {
            return false;
        }
    }

    const processPNPJ = async info => {
        const resp1 = await fb.firestore().collection('tarifasrpn').get();
        if(resp1.size != 0) {
            for(let doc of resp1.docs) {
                const response = await getValueMatPerson(info.actperson, doc.data(), data.nombre);
                console.log(response);
                if(response) {
                    dispatch({ type: 'add', payload: response });
                    break;
                }
            }
            if(data.establecimientos.length > 0) {
                const resp2 = await fb.firestore().collection('tarifasres').get();
                if(data.establecimientos.length === 1) {
                    for(let doc of resp2.docs) {
                        if(data.establecimientos[0].ultanorenovado === (new Date().getFullYear() -1).toString()) {
                            const response = await getValueMatEstSuc(info.actestable, doc.data(), data.establecimientos[0].nombre);

                            if(response) {
                                dispatch({ type: 'add', payload: response });
                                break;
                            }
                        }
                    }   
                } else {
                    data.establecimientos.map(async (estable, key) => {
                        for(let doc of resp2.docs) {
                            if(estable.ultanorenovado === (new Date().getFullYear() -1).toString()) {
                                console.log(estable.ultanorenovado);
                                const response = await getValueMatEstSuc(info[`actestable${(key+1)}`], doc.data(), estable.nombre);
                        
                                if(response) {
                                    dispatch({ type: 'add', payload: response });
                                }
                            }
                        }
                    });
                }
            }
        }
    }

    const processAffiliate = async info => {
        const resp = await fb.firestore().collection('tarifasafi').get();

        if(resp.size != 0) { 
            for(let doc of resp.docs) {
                const response = await getValueAffiliate(info.actperson, doc.data());
                if(response) {
                    setAffiliation(response);
                    break;
                }
            }
        }
    }

    const getValueMatPerson = (actperson, tarifa, nombre) => {
        if(Number(actperson) > tarifa.mayora && Number(actperson) <= tarifa.menora) {
            return new Promise((resolve, reject) => resolve({title: nombre.toLowerCase(), value: tarifa.valor}));
        }
    }

    const getValueMatEstSuc = (actestable, tarifa, establecimientos) => {
        if(actestable > tarifa.mayora && actestable <= tarifa.menora) { 
            return new Promise((resolve, reject) => resolve({title: establecimientos.toLowerCase(), value: tarifa.valor}));
        }
    }

    const getValueAffiliate = (actperson, tarifa) => {
        if(Number(actperson) > tarifa.mayora && Number(actperson) <= tarifa.menora) {
            return new Promise((resolve, reject) => resolve({title: 'afiliación', value: tarifa.valor}));
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.container}>
            {
                data.ultanorenovado === (new Date().getFullYear() -1).toString() && (
                    <div className={classes.containerperson}>
                        <div className={classes.head}>
                            <div className={classes.title}>{data.nombre}</div>
                            <div className={classes.subtitle}>últimos activos reportados: {numberFormat(data.activos)}</div>
                            <div className={classes.subtitle}>año: {data.ultanorenovado}</div>
                            {data.afiliado === '1' && (
                                <div className={classes.afiliate}>
                                    <StarRate htmlColor='#F7DC6F' />
                            afiliado
                                </div>
                            )}
                        </div>

                        <Controller
                            name='actperson'
                            control={control}
                            defaultValue=''
                            render={({ onChange, value }) => (
                                <TextField
                                    error={errors.actperson ? true : false}
                                    label='Nuevo activo'
                                    helperText={
                                        (errors.actperson && errors.actperson.type === 'validate') ? `Los activos deben ser iguales o superiores a ${numberFormat(data.activos)}` : errors.actperson ? errors.actperson.message : 'Ingrese el valor de los nuevos activos'
                                    }
                                    fullWidth
                                    size='small'
                                    type='number'
                                    variant="outlined"
                                    style={{ marginBottom: 15, background: '#fff' }}
                                    value={value || ''}
                                    onChange={onChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                            rules={{
                                required: '* Campo obligatorio',
                                pattern: {
                                    value: /^[1-9]+[0-9]{2,}$/g,
                                    message: 'El valor de los activos no es correcto'
                                },
                                validate: () => {
                                    return parseInt(getValues('actperson')) >= data.activos;
                                }
                            }}
                        />
                    </div>
                )
            }
                            
            {
                (data.establecimientos.length) === 1 && (data.establecimientos[0].ultanorenovado === (new Date().getFullYear() -1).toString()) ? (
                    <div className={classes.containerestable}>
                        <div className={classes.head}>
                            <div className={classes.title}>{data.establecimientos[0].nombre}</div>
                            <div className={classes.subtitle}>últimos activos reportados: {numberFormat(parseInt(data.establecimientos[0].valorestablecimiento))}</div>
                            <div className={classes.subtitle}>año: {data.ultanorenovado}</div>
                        </div>

                        <Controller
                            name='actestable'
                            control={control}
                            defaultValue=''
                            render={({ onChange, value }) => (
                                <TextField
                                    error={errors.actestable ? true : false}
                                    label='Nuevo activo'
                                    helperText={ 
                                        //(errors.actestable && errors.actestable.type === 'activosmenor') ? `Los activos deben ser iguales o superiores a ${numberFormat(parseInt(data.establecimientos[0].valorestablecimiento))}`: (errors.actestable && errors.actestable.type === 'activosmayor') ? `Los activos deben ser iguales a ${numberFormat(parseInt(getValues('actperson')))}` : errors.actestable ? errors.actestable.message : 'Ingrese el valor de los nuevos activos' 
                                        (errors.actestable && errors.actestable.type === 'activosmayor') ? `Los activos deben ser iguales a ${numberFormat(parseInt(getValues('actperson')))}` : errors.actestable ? errors.actestable.message : 'Ingrese el valor de los nuevos activos'
                                    }
                                    fullWidth
                                    size='small'
                                    type='number'
                                    variant="outlined"
                                    style={{ marginBottom: 15, background: '#fff' }}
                                    value={value || ''}
                                    onChange={onChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                            rules={{
                                required: '* Campo obligatorio',
                                pattern: {
                                    value: /^[1-9]+[0-9]{2,}$/g,
                                    message: 'El valor de los activos no es correcto'
                                },
                                /*validate: () => {
                                    return parseInt(getValues('actestable')) >= parseInt(data.establecimientos[0].valorestablecimiento);
                                }*/
                                validate : {
                                    //activosmenor: () => parseInt(getValues('actestable')) >= parseInt(data.establecimientos[0].valorestablecimiento),
                                    activosmayor: () => parseInt(getValues('actestable')) == parseInt(getValues('actperson'))
                                }
                            }}
                        />
                    </div>
                ) : data.establecimientos.length > 1 && data.establecimientos.map((estable, key) => {
                    if(estable.ultanorenovado === (new Date().getFullYear() -1).toString()) {
                        return (
                            <div className={classes.containerestable} key={key.toString()}>
                                <div className={classes.head}>
                                    <div className={classes.title}>{estable.nombre}</div>
                                    <div className={classes.subtitle}>últimos activos reportados: {numberFormat(parseInt(estable.valorestablecimiento))}</div>
                                    <div className={classes.subtitle}>año: {estable.ultanorenovado}</div>
                                </div>

                                <Controller
                                    name={`actestable${(key + 1)}`}
                                    control={control}
                                    defaultValue=''
                                    render={({ onChange, value }) => (
                                        <TextField
                                            error={errors[`actestable${(key + 1)}`] ? true : false}
                                            label='Nuevo activo'
                                            helperText={
                                                //(errors[`actestable${(key + 1)}`] && errors[`actestable${(key + 1)}`].type === 'validate') ? `Los activos deben ser iguales o superiores a ${numberFormat(parseInt(estable.valorestablecimiento))}` : errors[`actestable${(key + 1)}`] ? errors[`actestable${(key + 1)}`].message : 'Ingrese el valor de los nuevos activos'
                                                (errors[`actestable${(key + 1)}`] && errors[`actestable${(key + 1)}`].type === 'activosmayor') ? `Los activos deben ser iguales o inferiores a ${numberFormat(parseInt(getValues('actperson')))}` : errors[`actestable${(key + 1)}`] ? errors[`actestable${(key + 1)}`].message : 'Ingrese el valor de los nuevos activos'
                                            }
                                            fullWidth
                                            size='small'
                                            type='number'
                                            variant="outlined"
                                            style={{ marginBottom: 15, background: '#fff' }}
                                            value={value || ''}
                                            onChange={onChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                    rules={{
                                        required: '* Campo obligatorio',
                                        pattern: {
                                            value: /^[1-9]+[0-9]{2,}$/g,
                                            message: 'El valor de los activos no es correcto'
                                        },
                                        /*validate: () => {
                                            return parseInt(getValues(`actestable${(key + 1)}`)) >= parseInt(estable.valorestablecimiento);
                                        }*/
                                        validate : {
                                            //activosmenor: () => parseInt(getValues('actestable')) >= parseInt(data.establecimientos[0].valorestablecimiento),
                                            activosmayor: () => parseInt(getValues(`actestable${(key + 1)}`)) <= parseInt(getValues('actperson'))
                                        }
                                    }}
                                />
                            </div>
                        )
                    } 
                })
            }
            
            <Button
                variant="contained"
                color="primary"
                startIcon={!isLoading && <Send />}
                fullWidth
                style={{ paddingTop: 7, paddingBottom: 7, marginTop: 10, background: '#4caf50', color: '#fff' }}
                size='medium'
                type='submit'
            >
                {isLoading ? 'Procesando...' : 'Generar liquidación'}
            </Button>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                <Button color='primary' size='small' startIcon={<KeyboardArrowLeft />} onClick={() => setData(null)}>regresar</Button>
            </div>
        </form>
    )
}

const useStyles = makeStyles({
    container: {
        background: '#fff',
        width: 400,
        margin: 10,
        padding: 20,
        borderRadius: 6,
        maxHeight: 410,
        overflowY: 'auto',
        borderWidth: 1,
        borderColor: '#CACFD2',
        borderStyle: 'solid'
    },
    head: {
        marginBottom: 20
    },
    title: {
        fontFamily: 'Roboto',
        fontWeight: '500',
        marginBottom: 1
    },
    subtitle: {
        fontFamily: 'Roboto',
        color: 'grey',
        fontSize: 14
    },
    afiliate: {
        fontFamily: 'Roboto',
        background: '#28B463',
        color: '#fff',
        fontSize: 14,
        borderRadius: 4,
        width: 75,
        marginTop: 5,
        display: 'flex',
        alignItems: 'center'
    }
   
});

export default FormLiquidation;